module.exports = new __parcel__URL__("glider.19e4343a.jpg").toString();